import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";

const news = articles.filter((item) => item.type === "news").slice(0, 5);

export default function NewsSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <SectionHeading
        eyebrow="News"
        title="最新影视资讯"
        description="修复计划、回顾影展与影史动态，了解经典电影的当下。"
        linkTo="/guides"
        linkLabel="查看更多资讯"
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
        <Link
          to="/guides"
          className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
        >
          <div className="relative w-full h-56 md:h-72 overflow-hidden bg-background-200">
            <img
              src={news[0].cover}
              alt={news[0].title}
              title={`${news[0].title} - 影视资讯`}
              className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
            />
            <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs">
              {news[0].tag}
            </span>
          </div>
          <div className="p-5">
            <p className="text-xs text-foreground-500 mb-2">{news[0].date}</p>
            <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
              {news[0].title}
            </h3>
            <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
              {news[0].excerpt}
            </p>
          </div>
        </Link>

        <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          {news.slice(1).map((item) => (
            <Link
              key={item.id}
              to="/guides"
              className="group flex items-start gap-4 p-4 md:p-5 hover:bg-background-100 transition-colors"
            >
              <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
                <i className="ri-newspaper-line text-lg"></i>
              </span>
              <div className="min-w-0">
                <h4 className="font-heading text-sm md:text-base font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h4>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.excerpt}</p>
                <p className="mt-1.5 text-xs text-foreground-400">{item.date}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}